import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=42a8ac31&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=42a8ac31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a8ac31",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogFilterMobileMenu: require('/app/components/blog/BlogFilterMobileMenu.vue').default,BlogTrendingSection: require('/app/components/blog/BlogTrendingSection.vue').default,BlogContentAnchorSection: require('/app/components/blog/BlogContentAnchorSection.vue').default,BlogSideWidget: require('/app/components/blog/BlogSideWidget.vue').default,BlogSearchInputContainer: require('/app/components/blog/BlogSearchInputContainer.vue').default,BlogFilterSection: require('/app/components/blog/BlogFilterSection.vue').default,Breadcrumb: require('/app/components/common/breadcrumb.vue').default,BlogSingle: require('/app/components/blog/BlogSingle.vue').default,ImageBannerAd: require('/app/components/common/ImageBannerAd.vue').default,BlogAdvisorDesktopCard: require('/app/components/blog/BlogAdvisorDesktopCard.vue').default,BlogSidebarLayout: require('/app/components/blog/BlogSidebarLayout.vue').default,BlogRecommendedSection: require('/app/components/blog/BlogRecommendedSection.vue').default,DrifterZoneSideWidget: require('/app/components/drifter-zone/DrifterZoneSideWidget.vue').default,BlogAdvisorMobileCard: require('/app/components/blog/BlogAdvisorMobileCard.vue').default})
